/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import React from "react";
import {
  AboutDiv,
  InformationContainer,
  InformationDiv,
  InformationHeading,
  MainContainer,
  ProfileDiv,
} from "../../components/Profile/Profile.style";

import { useSelector } from "react-redux";
import { format, parse } from "date-fns";

// import PdfVolProfile from "./PdfVolProfile";

const WebVolunteerProfile = () => {
  const volunteerData = useSelector((state) => state.Modal.val);

  const dob = parse(volunteerData?.dob, "yyyy-MM-dd HH:mm:ss", new Date());
  const formattedDate = format(dob, "dd-MM-yyyy");
  // const femaleStatus = volunteerData?.sex;

  return (
    <>
      <ProfileDiv>
        {/* <div
          style={{
            display: "grid",
            gridTemplateColumns: "4fr 2fr",
            gap: "1rem",
          }}
        > */}
        {/* ========== volunteer profile image start ========= */}
        {/* {femaleStatus === "Female" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || girl}
                alt=""
              />
            </div>
          )}

          {femaleStatus === "Male" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || profile}
                alt=""
              />
            </div>
          )}

          {femaleStatus === "Others" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || profile}
                alt=""
              />
            </div>
          )} */}
        {/* ========== volunteer profile image end ========= */}
        {/* </div> */}

        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <AccountCircleIcon></AccountCircleIcon>
          <span
            style={{
              // color: "#1a202c",
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            About
          </span>
        </AboutDiv>

        <MainContainer>
          {/* ========= name ========== */}
          <InformationContainer>
            <InformationHeading>First Name:</InformationHeading>
            <InformationDiv>{volunteerData?.f_name}</InformationDiv>
          </InformationContainer>
          {/* ======= last name ====== */}
          <InformationContainer>
            <InformationHeading>Last Name:</InformationHeading>
            <InformationDiv>{volunteerData?.l_name}</InformationDiv>
          </InformationContainer>

          {/* ======= mobile number ====== */}
          <InformationContainer>
            <InformationHeading>Mobile Number:</InformationHeading>
            <InformationDiv>{volunteerData?.mobile_no}</InformationDiv>
          </InformationContainer>

          {/* ============= date of birth ========== */}
          <InformationContainer>
            <InformationHeading>Date of Birth:</InformationHeading>
            <InformationDiv>{formattedDate}</InformationDiv>
          </InformationContainer>

          {/* ============= Age ========== */}
          <InformationContainer>
            <InformationHeading>Age:</InformationHeading>
            <InformationDiv>{volunteerData?.age}</InformationDiv>
          </InformationContainer>

          {/* ===== Gender ======= */}
          <InformationContainer>
            <InformationHeading>Sex: </InformationHeading>
            <InformationDiv>
              {volunteerData?.gender.toUpperCase()}
            </InformationDiv>
          </InformationContainer>

          {/* ======= marital_status ======== */}
          <InformationContainer>
            <InformationHeading>Marital Status: </InformationHeading>
            <InformationDiv>
              {volunteerData?.marital_status.toUpperCase()}
            </InformationDiv>
          </InformationContainer>

          {/* ======= id type and number ======== */}
          <InformationContainer>
            <InformationHeading>
              {volunteerData?.id_type.toLowerCase() === "brc"
                ? "Birth Registration:"
                : "NID:"}
            </InformationHeading>
            <InformationDiv>
              {volunteerData?.id_type.toLowerCase() === "brc"
                ? volunteerData?.birth_reg
                : volunteerData?.nid}
            </InformationDiv>
          </InformationContainer>

          {/* ======= supportive nid ======== */}
          {volunteerData?.gender === "female" && (
            <InformationContainer>
              <InformationHeading>
                {volunteerData?.gender.toLowerCase() === "female" &&
                volunteerData?.marital_status.toLowerCase() === "married"
                  ? "Husband NID:"
                  : "Parent NID:"}
              </InformationHeading>
              <InformationDiv>{volunteerData?.supportive_nid}</InformationDiv>
            </InformationContainer>
          )}

          {/* ======= smoking habit ======== */}
          <InformationContainer>
            <InformationHeading>Smoking Habit: </InformationHeading>
            <InformationDiv>
              {volunteerData?.smoking_habit.toUpperCase()}
            </InformationDiv>
          </InformationContainer>

          {/* ======= weight ======== */}
          <InformationContainer>
            <InformationHeading>Weight: </InformationHeading>
            <InformationDiv>{volunteerData?.weight} Kg</InformationDiv>
          </InformationContainer>
        </MainContainer>
      </ProfileDiv>
      {/* <PDFViewer>
      <PdfVolProfile volunteerData={volunteerData} history={history} />
  </PDFViewer> */}
      {/* <PdfDiv>
        <PdfVolProfile volunteerData={volunteerData} history={history} />
      </PdfDiv> */}
    </>
  );
};

export default WebVolunteerProfile;
